export default "__VITE_ASSET__CDGlkbg___"